import prettyBytes from 'pretty-bytes';
export const getFixedFilesize = (bytes) => {
    return prettyBytes(bytes, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
